import { formatOrgNum } from "@/utils/other";
import { observer } from "mobx-react";
import { Alert } from "@/components-v2/Alert";
import { ChangeOfAccountantForm } from "./accountantDomain";
import { VBox } from "@/components-v2/Box";
import { Autocomplete } from "@/components-v2/Autocomplete";
import { MTextInput } from "@/components-v2/TextInput";

import { useTranslation } from "@/stores/RootStoreContext";

const AccountantAutocomplete = observer(function AccountantAutocomplete({
  form,
}: {
  form: ChangeOfAccountantForm;
}) {
  const { t } = useTranslation();
  return (
    <VBox>
      <Autocomplete
        label={t("decisions.accountant.select")}
        disabled={form.isProjectLocked}
        items={form.suggestedCompanyForAccountants}
        value={form.selectedCompanyForAccountant}
        idFn={(item) => item.organizationnumber}
        labelFn={(item) => item.name}
        inputValue={form.searchCompanyModel.inputValue}
        onInputValueChange={form.setCompanySearch}
        onSelect={form.setSelectedCompanyForAccountant}
        onClear={form.clearSelectedAccountant}
      />
      {form.validationError && <Alert type={"error"} message={<>{t(form.validationError)}</>} />}
    </VBox>
  );
});

export const ChangeOfAccountantView = observer(function ChangeOfAccountantView({
  form,
}: {
  form: ChangeOfAccountantForm;
}) {
  const { t } = useTranslation();
  const orgNoPrefix = t("decisions.accountant.orgNoPrefix");

  return (
    <VBox gap={"md"}>
      {form.currentAccountant ? (
        <div>
          <div>{t("decisions.accountant.company-accountant-now")}</div>
          {`${form.currentAccountant.name} (${orgNoPrefix} ${formatOrgNum(
            form.currentAccountant.organisationNumber,
          )})`}
        </div>
      ) : (
        <div>
          <div>{t("decisions.accountant.company-no-accountant")}</div>
        </div>
      )}
      <AccountantAutocomplete form={form} />
      {form.selectedCompanyForAccountant && (
        <VBox gap="md">
          <div>
            <div>{t("decisions.accountant.company-accountant-willbe")}</div>
            <strong>{form.selectedCompanyForAccountant.name}</strong>
            {` (${orgNoPrefix} ${formatOrgNum(form.selectedCompanyForAccountant.organizationnumber)})`}
          </div>
          <MTextInput model={form.emailModel} label={t("decisions.accountant.email")} />
        </VBox>
      )}
    </VBox>
  );
});
